import React, { useState, useContext } from "react";
import { Formik, Field, Form } from "formik";
import { Row, Col, Alert, Button } from "react-bootstrap";
import apiContext from "../../context/Api";
import { Link } from "react-router-dom";
import * as Yup from "yup";

const SignalForm = () => {
  //Initial Values
  const initialValues =
    "production" === process.env.NODE_ENV
      ? {
          name: "",
          email: "",
          phone: "",
          organization: "",
          toggle: false,
        }
      : {
          name: "Иванов Иван Иванович",
          email: "ivanov@ivani.ru",
          phone: "+79855555555",
          organization: "ООО Рога и Копыта",
          toggle: true,
        };

  const [disabled, setDisabled] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [values, setValues] = useState(initialValues);

  const {
    /** @type Api */
    api,
  } = useContext(apiContext);

  // Submit form
  async function handleSubmit(e) {
    return api
      .opreglic(e.name, e.email, e.organization, e.phone)
      .then((result) => {
        const { error, name, email, phone, organization, content } = result;

        setValues((values) => ({
          ...values,
          name: name,
          email: email,
          phone: phone,
          organization: organization,
          content: content,
          error: error,
        }));
        console.log(result);
        switch (result.status.code) {
          case 200:
            setDisabled(true);
            break;
          case 500:
            setValues({ error: "Произошла ошибка при обращении к серверу" });
            break;
          case 502:
            setValues({ error: "Произошла ошибка при обращении к серверу" });
            break;
          default:
            console.log("error server");
            break;
        }
      });
  }
  // Button check disable
  const checkDisabled = (error, submit) => {
    let size = Object.keys(error).length;
    if (size >= 1) setDisabledButton(true);
    else setDisabledButton(false);
  };

  return (
    <Row className="mt-5">
      <Col lg={2}></Col>
      <Col lg={8} className="shadow-sm bg-light  pb-5">
        {values.content ? (
          <h5 className="my-0 text-center text-success pb-1 pt-3">
            Запрос отправлен
          </h5>
        ) : (
          <h5 className="text-dark pb-1 pt-4">
            Форма запроса программного обеспечения и QR-кода лицензии
          </h5>
        )}
        <Formik
          initialValues={{
            name: values.name,
            email: values.email,
            phone: values.phone,
            organization: values.organization,
            toggle: values.toggle,
            checked: [],
          }}
          onSubmit={handleSubmit}
          validationSchema={Yup.object({
            name: Yup.string()
              .matches(/^[а-яё. -]+$/iu, "Укажите Фамилию Имя Отчество")
              .max(50, "Максимальное количество символов 50")
              .min(5, "Минимальное количество символов 5")
              .required("Необходимо указать ФИО"),
            email: Yup.string()
              .email("Указан некорректный email")
              .required("Необходимо указать email"),
            // organization:
            toggle: Yup.bool().oneOf(
              [true],
              "Вы должны принять пользовательское соглашение"
            ),
            phone: Yup.string()
              .matches(
                /^[+\d -]+$/,
                "Неверно указан номер, допускаются только цифры"
              )
              .min(11, "Неверно указан номер, меньше 11 цифр")
              .max(12, "Неверно указан номер, больше 11 цифр")
             
              .typeError("Укажите номер телефона"),
          })}
        >
          {(formik) => (
            <Form
              className={disabled ? "fade d-none px-3" : "show fade d-block "}
            >
              <Row>
                <Col md={6} className="pt-3">
                  <label htmlFor="name">
                    Фамилия, Имя, Отчество:
                    <span className="text-danger">*</span>
                  </label>
                  <Field
                    name="name"
                    disabled={disabled}
                    className={
                      formik.touched.name && formik.errors.name
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    type="text"
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <div className="invalid-feedback">{formik.errors.name}</div>
                  ) : null}
                </Col>
                <Col md={6} className="pt-3">
                  <label htmlFor="email">
                    Электронная почта:<span className="text-danger">*</span>
                  </label>
                  <Field
                    name="email"
                    disabled={disabled}
                    className={
                      formik.touched.email && formik.errors.email
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    type="email"
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div className="invalid-feedback">
                      {formik.errors.email}
                    </div>
                  ) : null}
                </Col>
                <Col md={6} className="pt-3">
                  <label htmlFor="phone">
                    Контактный телефон: 
                  </label>
                  <Field
                    name="phone"
                    placeholder="+79999999999"
                    disabled={disabled}
                    className={
                      formik.touched.phone && formik.errors.phone
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    type="text"
                  />
                  {formik.touched.phone && formik.errors.phone ? (
                    <div className="invalid-feedback">
                      {formik.errors.phone}
                    </div>
                  ) : null}
                </Col>
                <Col md={6} className="pt-3">
                  <label htmlFor="organization">
                    Наименование организации:
                  </label>
                  <Field
                    name="organization"
                    disabled={disabled}
                    className={
                      formik.touched.organization && formik.errors.organization
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    type="text"
                  />
                  {formik.touched.organization && formik.errors.organization ? (
                    <div className="invalid-feedback">
                      {formik.errors.organization}
                    </div>
                  ) : null}
                </Col>
           
                <span className="py-2">
                  На данный адрес придет инструкция по скачиванию и лицензия
                </span>
                <Col md={12}>
                  <label className="form-check-label" htmlFor="invalidCheck">
                    <Field
                      id="invalidCheck"
                      type="checkbox"
                      name="toggle"
                      className={
                        formik.touched.toggle && formik.errors.toggle
                          ? "is-invalid form-check-input"
                          : "form-check-input"
                      }
                    />

                    <span className="ps-2">
                      Я даю свое согласие на обработку и использование моих персональных данных
                    </span>

                    {formik.touched.toggle && formik.errors.toggle ? (
                      <div className="invalid-feedback">
                        {formik.errors.toggle}
                      </div>
                    ) : null}
                  </label>
                </Col>
                <Col md={12}>
                  <div className="d-grid">
                    <Button
                      type="submit"
                      className="btn btn-lg btn-success mt-5"
                      onFocus={checkDisabled(
                        formik.errors,
                        formik.isSubmitting
                      )}
                      disabled={disabledButton}
                    >
                      {disabled
                        ? "форма отправлена"
                        : formik.isSubmitting
                        ? "Отправка..."
                        : "Отправить заявку"}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
        {values.error ? (
          <Alert variant="warning" className="fade  pt-3 mt-5 ">
            {values.error}
          </Alert>
        ) : values.content ? (
          <>
            <Alert variant="success" className="fade px-4 mt-3 text-center">
              <img
                alt="qr"
                className="img-fluid"
                style={{ maxWidth: "40%" }}
                src={"data:image/png;base64," + values.content.license}
              />
            </Alert>
          </>
        ) : (
          ""
        )}
      </Col>
      <Col lg={2}></Col>
    </Row>
  );
};

export default SignalForm;
